import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

// const Users = lazy(() => import('../../container/users/Users'));
const Daily = lazy(() => import('../../container/reports/daily/Daily'));
const ReportOne = lazy(() => import('../../container/reports/report1/ReportOne'));

const NotFound = lazy(() => import('../../container/pages/404'));

function PagesRoute() {
  return (
    <Routes>
      {/* <Route path="/*" element={<Users />} /> */}
      <Route path="daily-report/*" element={<Daily />} />
      <Route path="report-one/*" element={<ReportOne />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default PagesRoute;
